import { paths } from 'src/routes/paths';

import axios from 'src/lib/axios';

import { JWT_STORAGE_KEY } from './constant';
import { clearAmplifyConfig } from './config';

// ----------------------------------------------------------------------

export function jwtDecode(token: string) {
  if (!token) return null;

  const parts = token.split('.');
  if (parts.length < 2) {
    throw new Error('Invalid token!');
  }

  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const decoded = JSON.parse(atob(base64));

  return decoded;
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken: string) {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  if (!decoded || !('exp' in decoded)) {
    return false;
  }

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
}

// ----------------------------------------------------------------------

export function tokenExpired(exp: number, onExpired?: () => void) {
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;

  if (timeLeft > 0) {
    setTimeout(() => {
      if (onExpired) {
        onExpired();
      } else {
        sessionStorage.removeItem(JWT_STORAGE_KEY);
        clearAmplifyConfig();
        window.location.href = paths.auth.amplify.signIn;
      }
    }, timeLeft);
  }
}

// ----------------------------------------------------------------------

export async function setSession(accessToken: string | null, onTokenExpired?: () => void) {
  if (accessToken) {
    sessionStorage.setItem(JWT_STORAGE_KEY, accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    const decodedToken = jwtDecode(accessToken);

    if (decodedToken && 'exp' in decodedToken) {
      tokenExpired(decodedToken.exp, onTokenExpired);
    }
  } else {
    sessionStorage.removeItem(JWT_STORAGE_KEY);
    delete axios.defaults.headers.common.Authorization;
    clearAmplifyConfig();

    sessionStorage.removeItem('jwt_timestamp');
  }
}

// ----------------------------------------------------------------------

export function clearAllAuthData() {
  sessionStorage.removeItem(JWT_STORAGE_KEY);
  sessionStorage.removeItem('jwt_timestamp');
  delete axios.defaults.headers.common.Authorization;
  clearAmplifyConfig();
}
